import { useEffect, useState } from 'react';

import {
  Badge,
  Button, Menu, PageHeader, Table, Image, Timeline, Typography,
} from 'antd';
import { ClockCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Content } from 'antd/lib/layout/layout';
import { Box } from 'components/Box';
import { observer } from 'mobx-react';
import BorderedBox from 'components/BorderedBox/BorderedBox';
import useRequest from 'hooks/useRequest';
import { listOzonProd } from 'configs';
import { useMount } from 'hooks';

import useRequestOzone from './useRequestOzone';
import { getProdIds, getProdList } from './OzonPage';

const COLUMN_NOT_SYNC: any = [
  {
    title: '',
    dataIndex: 'primary_image',
    fixed: 'left',
    width: 70,
    minWidth: 70,
    key: '1',
    ellipsis: true,
    render: (row: any) => (
      <Image
        width={50}
        height={50}
        src={row}
        // eslint-disable-next-line max-len
        fallback="data:image/png;base64,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"
      />
    ),
  },
  {
    title: 'Название товара',
    dataIndex: 'name',
    fixed: 'left',
    width: 250,
    minWidth: 250,
    key: '2',
    ellipsis: true,
    render: (row: any) => (<Typography.Link>{row}</Typography.Link>),
  },
  {
    title: 'barcode',
    dataIndex: 'barcode',
    key: 'barcode',
    ellipsis: true,
    render: (row: any) => (<Typography.Text type="secondary">{row}</Typography.Text>),
  },
  {
    title: 'fbo_sku',
    dataIndex: 'fbo_sku',
    key: 'fbo_sku',
    ellipsis: true,
    render: (row: any) => (<Typography.Text type="secondary">{row}</Typography.Text>),
  },
  {
    title: 'ozon_id',
    dataIndex: 'ozon_id',
    key: 'ozon_id',
    ellipsis: true,
    render: (row: any) => (<Typography.Text type="secondary">{row}</Typography.Text>),
  },
  {
    title: 'offer_id',
    dataIndex: 'offer_id',
    key: 'offer_id',
    ellipsis: true,
    render: (row: any) => (<Typography.Text type="secondary">{row}</Typography.Text>),
  },
  {
    title: 'market_price',
    dataIndex: 'market_price',
    key: 'market_price',
    ellipsis: true,
    render: (row: any) => (<Typography.Text type="secondary">{row}</Typography.Text>),
  },
  {
    title: 'stock / reserve',
    dataIndex: 'stock',
    key: 'stock',
    ellipsis: true,
    render: (row: any, list: any) => (<Typography.Text type="secondary">{`${row} / ${list.reserve}`}</Typography.Text>),
  },
  {
    title: 'multiple',
    dataIndex: 'multiple',
    key: 'stock',
    ellipsis: true,
    render: (row: any) => (<Typography.Text type="secondary">{`${row ? 'M' : 'S'}`}</Typography.Text>),
  },
];

const OzoneProducts = () => {
  const { fetch, isLoading, requestResult: pids, isSuccess } = useRequestOzone(getProdIds);
  const { fetch: fetchList, isLoading: isLoadingList, requestResult: list, isSuccess: isSuccesList } = useRequestOzone(getProdList);
  const { fetch: fetchDk, isLoading: isLoadingDk, requestResult: listDk, isSuccess: isSuccesListDk } = useRequest(listOzonProd);
  const [addedList, setAddedList] = useState<any[]>([]);
  const [newestList, setnewestList] = useState<any[]>([]);
  const [current, setCurrent] = useState<string>('sync');

  const getPL = () => {
    fetch({ limit: 1000 });
  };

  useEffect(() => {
    if (!pids) return;
    const { result } = pids;
    const l = result.items.map((el: any) => el.product_id);
    fetchList({ product_id: l });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pids]);

  useEffect(() => {
    if (!list) return;
    fetchDk({});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);

  useEffect(() => {
    if (!listDk) return;
    setAddedList(listDk.records);
    const { result } = pids;
    // GET OZON IDS
    const lOIDS = result.items.map((el: any) => el.product_id);

    // GET BASE IDS
    const lBIDS = listDk.records.map((el: any) => el.ozon_id);

    // FILTER NEW OIDS
    const NOIDS = lOIDS.filter((el: number) => !lBIDS.includes(el));

    // LiST TO ADD
    const newList = list.result.items.filter((el: any) => NOIDS.includes(el.id));
    const cleanList = newList.map((el: any) => ({
      barcode: el.barcode,
      img: el.images,
      fbo_sku: el.fbo_sku,
      fbs_sku: el.fbs_sku,
      ozon_id: el.id,
      offer_id: el.offer_id,
      market_price: el.marketing_price,
      stock: el.stocks.present,
      reserve: el.stocks.reserved,
      product_id: 0,
      multiple: el.multiple === '1',
      count: 1,
      name: el.name,
      primary_image: el.primary_image,
      content_rate: el.rating,
    }));
    setnewestList(cleanList);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listDk]);

  const items: any = [{
    color: isSuccess ? 'green' : 'red',
    dot: isLoading ? <ClockCircleOutlined style={{ fontSize: '16px' }} /> : isSuccess ? <CheckCircleOutlined style={{ fontSize: '16px', color: 'green' }} /> : null,
    children: 'Получение id товаров озон',
  },
  {
    color: isSuccesList ? 'green' : 'red',
    dot: isLoadingList ? <ClockCircleOutlined style={{ fontSize: '16px' }} /> : isSuccesList ? <CheckCircleOutlined style={{ fontSize: '16px', color: 'green' }} /> : null,
    children: 'Получение списка товаров озон',
  },
  {
    color: isSuccess ? 'green' : 'red',
    dot: isLoadingDk ? <ClockCircleOutlined style={{ fontSize: '16px' }} /> : isSuccesListDk ? <CheckCircleOutlined style={{ fontSize: '16px', color: 'green' }} /> : null,
    children: 'Получение списка со склада магазин',
  },
  ];

  const BoxMenu = ({ count, name, id }: any) => (
    <Badge.Ribbon text={count}>
      <Box
        className={`menuTableBox_${current === id ? 'active' : 'stock'}`}
        padding={[0, 5]}
      >
        {name}
      </Box>
    </Badge.Ribbon>
  );

  const menu = [
    {
      label: 'Синхронизированы',
      count: addedList.length,
      key: 'sync',
    },
    {
      label: 'Не синхронизированы',
      count: newestList.length,
      key: 'no_sync',
    },
  ];

  const m = menu?.map((el: any) => ({
    label: <BoxMenu count={el.count} name={el.label} id={el.key} />,
    key: el.key,
  }));

  useMount(getPL);

  return (
    <>
      <PageHeader
        title="Список товаров на OZON"
        extra={<Button onClick={() => getPL()}>Синхронизировать с OZON</Button>}
      />
      <Content>
        <BorderedBox>
          <Timeline>
            {items.map((el: any) => (
              <Timeline.Item dot={el.dot}>
                {el.children}
              </Timeline.Item>
            ))}
          </Timeline>
        </BorderedBox>

        <Box className="tableBox" padding={[2, 0]} margin={[4, 0]}>
          <Menu
            mode="horizontal"
            onClick={(e: any) => setCurrent(e.key)}
            selectedKeys={[current]}
            items={m}
          />
          <Table
            columns={current === 'sync' ? [] : COLUMN_NOT_SYNC}
            dataSource={current === 'sync' ? addedList : newestList}
            style={{ width: '1300px' }}
            size="small"
            loading={isLoading}
            pagination={false}
          />
        </Box>

      </Content>
    </>
  );
};

export default observer(OzoneProducts);
